import { css } from '@emotion/core';

export const card = (theme) => css`
  background: #fff;
  border-radius: 16px;
  padding: ${theme.getSpacing(3, 'px')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const icon = (theme) => css`
  margin-bottom: ${theme.getSpacing(2, 'px')};

  svg {
    width: 140px;
    height: 120px;
  }
`;

export const titleText = (theme) => css`
  font-family: ${theme.getFont('leagueSpartan')};
  font-size: ${theme.getFontSize(1.5, 'px')};
  font-weight: 700;
  color: ${theme.getColor('text')};
  text-align: center;
  margin-bottom: ${theme.getSpacing(1, 'px')};
`;

export const subtitleText = (theme) => css`
  font-family: ${theme.getFont()};
  font-size: ${theme.getFontSize(0.9, 'px')};
  color: ${theme.getColor('text')};
  text-align: center;
  margin-bottom: ${theme.getSpacing(2, 'px')};
`;

export const tableInput = (theme) => css`
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 28px;
  padding: ${theme.getSpacing(1.5, 'px')} ${theme.getSpacing(2, 'px')};
  font-family: ${theme.getFont()};
  font-size: ${theme.getFontSize(1, 'px')};
  color: ${theme.getColor('text')};
  margin-bottom: ${theme.getSpacing(2, 'px')};
  outline: none;
  text-align: center;

  &::placeholder {
    color: ${theme.getColor('text')}80;
  }
`;

export const tableModalWrapper = {
  zIndex: 9999,
};

export const tableModalInnerWrapper = {
  top: '50%',
  left: '50%',
  maxWidth: 380,
  width: '90%',
  transform: 'translate(-50%, -50%)',
};

export const tableModalContent = {
  borderRadius: '16px',
  padding: 0,
  height: 'auto',
  boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
};
